import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './CmsMapping.scss';
import { extractAndAppendScriptSourceForCMS } from '../../../utils/helper';
import Customevent from '../../../utils/Customevent';
import Helmet from 'react-helmet';

class CmsMapping extends PureComponent {
  static propTypes = {
    isCollectionData: PropTypes.bool,
    cmsData: PropTypes.string,
  };
  componentDidMount() {
    const { location, isCollectionData, cmsData, commonAction, redisCommonData } = this.props;
    let path = location.pathname;
    path = path.substr(1);
    const url = window.location.href;
    if (window.dtm.LenskartRewamp) {
      window.dtm.LenskartRewamp.cms.load.cmsOnLoad(path, url);
    }
    if (!isCollectionData) extractAndAppendScriptSourceForCMS(cmsData);
    if (!isCollectionData) {
      if (
        redisCommonData.RBI_POLICY_MARKETPLACE_CONFIG &&
        JSON.parse(redisCommonData.RBI_POLICY_MARKETPLACE_CONFIG).listing === 'ON'
      ) {
        if (
          path.toLowerCase()?.indexOf('sun') > -1 ||
          path.toLowerCase()?.indexOf('contact') > -1 ||
          path.toLowerCase()?.indexOf('solution') > -1 ||
          path.toLowerCase()?.indexOf('accessor') > -1 ||
          path.toLowerCase()?.indexOf('reading') > -1
        ) {
          commonAction.changeLogo('dealskart');
        } else {
          commonAction.changeLogo('lenskart');
        }
      } else {
        commonAction.changeLogo('lenskart');
      }
    }
    const event = new Customevent('cmspageloaded', {
      detail: {
        environment: process.env.BUILD_ENV === 'production' ? 'prod' : 'dev',
        currPagePathname: location.pathname,
        currPageQueryParam: location.search,
        apiPath:
          process.env.BUILD_ENV === 'production'
            ? 'https://api.lenskart.com'
            : 'https://api-preprod.lenskart.com',
      },
    });
    event.dispatch();
  }
  componentWillUnmount() {
    this.props.commonAction.clearCmsData();
  }
  render() {
    const {
      cmsData,
      isCollectionData,
      location,
      localeInfo,
      dataLocale: { THIS_IS_COLLECTION_PAGE },
    } = this.props;
    const linkTags = [];
    // if (location.pathname === '/contact-lenses.html')
    //   linkTags.push({ rel: 'amphtml', href: `${localeInfo.domain}/amp${location.pathname}` });
    return (
      <div className="cms">
        <Helmet link={linkTags} />
        {isCollectionData ? (
          <h1>{THIS_IS_COLLECTION_PAGE}</h1>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: cmsData }}></div>
        )}
      </div>
    );
  }
}
CmsMapping.defaultProps = {
  isCollectionData: false,
  cmsData: '',
};

export default CmsMapping;
